The type of event, i.e. `CandidateApplicationCreated`.
